/* global axios */

import ApiClient from './ApiClient';

class WhatsappAccountAPI extends ApiClient {
  constructor() {
    super('whatsapp_accounts', { accountScoped: true });
  }

  get({ page, channel_id }) {
    const url = `${this.url}?page=${page}&channel_id=${channel_id}`;
    return axios.get(url);
  }

  all() {
    return axios.get(`${this.url}/all`);
  }

  session_qr(id) {
    return axios.post(`${this.url}/session_qr`, { id: id });
  }

  session_status(id) {
    return axios.post(`${this.url}/session_status`, { id: id });
  }

  session_logout(id) {
    return axios.post(`${this.url}/session_logout`, { id: id });
  }
}

export default new WhatsappAccountAPI();
